(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    const EMAIL_SIGNUP_SUBMIT_PREFIX = 'email-signup-submit-';

  function cleanCustomerFormUrl() {
    const url = new URL(window.location.href);
    let changed = false;

    if (url.searchParams.has('customer_posted')) {
      url.searchParams.delete('customer_posted');
      changed = true;
    }

    if (url.searchParams.get('form_type') === 'customer') {
      url.searchParams.delete('form_type');
      changed = true;
    }

    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('contact[')) {
        url.searchParams.delete(key);
        changed = true;
      }
    }

    if (changed) {
      const nextUrl = `${url.pathname}${url.search}${url.hash}`;
      history.replaceState({}, '', nextUrl);
    }
  }

  function resetEmailSignupInput(signup) {
    const input = signup.querySelector('.email-signup__input');
    if (!input) return;

    input.removeAttribute('aria-describedby');
    input.removeAttribute('aria-invalid');
  }

  function dismissEmailSignupMessage(signup, message, durationSeconds) {
    const dismissDelay = Number.isFinite(durationSeconds) && durationSeconds > 0
      ? durationSeconds * 1000
      : 5000;

    window.setTimeout(() => {
      message.classList.add('email-signup__message--dismissing');
      message.addEventListener(
        'animationend',
        () => {
          resetEmailSignupInput(signup);
          message.remove();
        },
        { once: true }
      );
    }, dismissDelay);
  }

  document.querySelectorAll('.email-signup').forEach((signup) => {
    const blockId = signup.dataset.blockId;
    const form = signup.querySelector('.email-signup__form');
    const feedbackMessages = signup.querySelectorAll('[data-email-signup-feedback]');
    const submitKey = `${EMAIL_SIGNUP_SUBMIT_PREFIX}${blockId}`;
    const durationSeconds = Number.parseInt(signup.dataset.messageDuration, 10);

    if (form) {
      form.addEventListener('submit', () => {
        sessionStorage.setItem(submitKey, '1');
      });
    }

    if (!feedbackMessages.length) return;

    const isFreshSubmission = sessionStorage.getItem(submitKey) === '1';

    if (isFreshSubmission) {
      sessionStorage.removeItem(submitKey);
      cleanCustomerFormUrl();

      feedbackMessages.forEach((message) => {
        message.classList.add('email-signup__message--visible');
        dismissEmailSignupMessage(signup, message, durationSeconds);
      });

      return;
    }

    feedbackMessages.forEach((message) => message.remove());
    resetEmailSignupInput(signup);
    cleanCustomerFormUrl();
  });
  } catch(e) { console.error(e); }
})();

})();
